<template>
<div :ref="LoadingObj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">vip详情</span>
        <div class="TTL-BTN-LIST">
            <wcbutton :option="{title:'返回设置管理',type:'del'}" class="left15" @finish="(val)=> {$parent.JUMPVIEW({name:'EsVip'})}" />
        </div>
    </div>

    <div class="ttl-goods-table top40">
        <table border="1" style="border-collapse: collapse;border-spacing: 0;">
            <tr>
                <th width="20%" align="center">vip名称</th>
                <th width="20%" align="center">有效时间</th>
                <th width="20%" align="center">开通价格</th>
                <th width="20%" align="center">是否支持微信群发</th>
                <th width="20%" align="center">是否支持批量分享</th>
            </tr>
            <tr>
                <td align="center">{{vipinfo.name}}</td>
                <td align="center">{{vipinfo.nums + vipinfo.type}}</td>
                <td align="center">{{vipinfo.price}}</td>
                <td align="center">{{vipinfo.isforward ? '是' : '否'}}</td>
                <td align="center">{{vipinfo.ismoreshare ? '是' : '否'}}</td>
            </tr>
            <tr>
                <th width="20%" align="center">续费次数</th>
                <th width="20%" align="center">续费金额</th>
                <th width="20%" align="center">添加时间</th>
                <th width="20%" align="center" colspan="2">活动时间</th>
            </tr>
            <tr>
                <td align="center">{{vipinfo.orders}}</td>
                <td align="center">{{vipinfo.orderprice}}</td>
                <td align="center">{{vipinfo.inputtime}}</td>
                <td align="center" colspan="2">
                    <div v-if="vipinfo.active_begintime!=''" class="activeTime">
                    <span>{{vipinfo.active_begintime+' ~ '+vipinfo.active_endtime}}</span>
                    <span>{{vipinfo.activestatusname}}</span>
                    </div>
                    <div v-if="vipinfo.active_begintime==''">/</div>
                </td>
            </tr>
        </table>
    </div>

    <div class="TTL-renew-detail top50">
        <span class="TTL-renew-title">vip充值记录</span>
        <div class="TTL-table top30">
            <el-table :data="detaillist" stripe="true" empty-text="" >
                <template v-slot:empty><el-empty description="暂无数据" /></template>
                <el-table-column label="充值会员" align="center" min-width="150">
                    <template #default="scope">
                        <wcimage :option="{size:'middle'}" :value="scope.row.memberavar" />
                    </template>
                </el-table-column>
                <el-table-column label="会员名称" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.membername}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="有效时间" align="center" min-width="150"> 
                    <template #default="scope">
                        <span class="renew-price">{{scope.row.nums+scope.row.type}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="充值金额" align="center" min-width="150"> 
                    <template #default="scope">
                        <span class="renew-price">{{scope.row.price}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="有效期" align="center" min-width="250">
                    <template #default="scope">
                        <span>{{scope.row.starttime+' ~ '+scope.row.endtime}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="transation_id" label="原始微信支付单号" align="center" min-width="180" />
                <el-table-column prop="inputtime" label="操作时间" align="center" min-width="180" />
            </el-table>
        </div>
    </div>
    <div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-page TTL-page-right">
            <wcpage :row="detailparam.rows" :p="detailparam.p" :rollpage="detailparam.rollpage"
                @finish="(val)=> {
                    detailparam.p=val.p;
                    detailparam.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
    </div>

            
</div>

</template>

<script>
import INTERFACE_MODEL_VIP from '@/Interface/Es/vip';

export default {
    components:{
        
    },
    data() {
        return {
            LoadingObj:'vipDetail',  //loading对象   
            vipinfo:{}, //vip信息详情
            detailparam: {
                id:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            detaillist:[],

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.GetVipInfo(data.param.id);
                this.detailparam.id=data.param.id;
                this.detailparam.ischange=true;
                this.GetList();
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetVipInfo(data.param.id);
                this.detailparam.id=data.param.id;
                this.detailparam.ischange=true;
                this.GetList();
            } 
        },


        /** 获取商品信息详情 **/
        GetVipInfo(id) {
            INTERFACE_MODEL_VIP.GET_VIP_DETAIL({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.vipinfo=res.data;
            });
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.detailparam.ischange) {
                this.detailparam.ischange=false;
                this.detailparam.p=1;
                this.detailparam.rollpage=10;
            }

            INTERFACE_MODEL_VIP.GET_VIP_DETAIL_LIST(this.detailparam).then((res) => {
                 if(res.status > 0) return false;
                 this.detailparam.rows=res.data.count;
                 this.detaillist=res.data.list;
            });
        },


        
        


    },
}
</script>
<style scoped>
.ttl-goods {padding:20px 15px 50px 15px;width:calc(100% - 30px);}
.ttl-member-info {display: inline-flex;align-items: center;width:100%;font-size:0;}
.ttl-member-info i {font-style: normal;color:#666eeb;font-size:13px;cursor: pointer;}
.ttl-member-info .el-image {width:80px;height:80px;border-radius: 50%;box-shadow: 0 0 10px #dddddd;}
.ttl-member-info span {display: inline-flex;align-items: center;font-size:13px;color:#666666;}
.ttl-frozen {box-shadow: 0 !important;width:20px !important;height: 20px !important;}
.ttl-member-status {display: inline-flex;align-items: center;}

.ttl-goods-table {display:inline-block;width:100%;}
.ttl-goods-table table {width:100%;border-color: #EBEDF0;padding:0;}
.ttl-goods-table table th {background-color: #EBEDF0;}
.ttl-goods-table table th,.ttl-goods-table table td {padding:20px;font-size:13px;color:#333333;font-weight: normal;}
.ttl-goods-table .el-image {width:60px;height: 60px;border-radius: 50%;}
.numbers {color:#666eeb;cursor: pointer;}
.member-phones {display: inline-flex;justify-content: center;align-items: center;}
.phone-copy {cursor: pointer;}
.activeTime,.activeTime span {display: inline-block;width:100%;text-align: center;}
</style>